/** Public build-time identifiers only (no secrets); see apps/web/Dockerfile. */
export const ENV = {
  /** `1` serves every API call from MSW fixtures (local design and test) */
  mock: import.meta.env.VITE_MOCK === "1" || import.meta.env.MODE === "test",
  environment: (import.meta.env.VITE_ENV as string | undefined) ?? "dev",
  /** Entra client id of the web app registration, used by the step-up popup (BR-175) */
  aadClientId: (import.meta.env.VITE_AAD_CLIENT_ID as string | undefined) ?? "",
  aadTenantAuthority:
    (import.meta.env.VITE_AAD_AUTHORITY as string | undefined) ?? "https://login.microsoftonline.com/common",
  apiScope: (import.meta.env.VITE_API_SCOPE as string | undefined) ?? "",
  /** token for browser-only development outside Teams */
  devToken: (import.meta.env.VITE_DEV_TOKEN as string | undefined) ?? "",
};
